import { render, staticRenderFns } from "./page_remove_device.vue?vue&type=template&id=143869be&scoped=true&"
import script from "./page_remove_device.vue?vue&type=script&lang=js&"
export * from "./page_remove_device.vue?vue&type=script&lang=js&"
import style0 from "./page_remove_device.vue?vue&type=style&index=0&id=143869be&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143869be",
  null
  
)

export default component.exports